function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M9.40039 4.56252V2.94665C9.08317 2.94665 8.82012 2.69111 8.82012 2.38297V0.458946C8.82012 0.202661 8.61122 0.000488281 8.34816 0.000488281H3.03288C1.3617 0.000488281 0 1.3225 0 2.94665V4.89246C0 5.04353 0.0618955 5.18633 0.170213 5.29155C0.27853 5.39601 0.425532 5.45614 0.580271 5.45614C1.16828 5.45614 1.61702 5.86199 1.61702 6.3956C1.61702 6.95252 1.16054 7.39594 0.588008 7.40271C0.270793 7.40271 0 7.62066 0 7.93632V9.8611C0 11.4845 1.3617 12.7997 3.02515 12.7997H8.34816C8.61122 12.7997 8.82012 12.5961 8.82012 12.3413V10.7171C8.82012 10.4022 9.08317 10.1535 9.40039 10.1535V8.69616C9.08317 8.69616 8.82012 8.43988 8.82012 8.13248V5.1262C8.82012 4.81806 9.08317 4.56252 9.40039 4.56252Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M14.383 6.39587C14.383 6.95203 14.8472 7.39546 15.412 7.40297C15.7292 7.40297 16 7.62093 16 7.92907V9.86061C16 11.4848 14.646 12.8 12.9749 12.8H10.4526C10.1973 12.8 9.98066 12.5963 9.98066 12.3408V10.7174C9.98066 10.4017 9.72534 10.1537 9.40039 10.1537V8.69642C9.72534 8.69642 9.98066 8.44014 9.98066 8.13275V5.12646C9.98066 4.81757 9.72534 4.56279 9.40039 4.56279V2.94616C9.72534 2.94616 9.98066 2.69062 9.98066 2.38248V0.45921C9.98066 0.202924 10.1973 0 10.4526 0H12.9749C14.646 0 16 1.31525 16 2.93864V4.8326C16 4.98291 15.9381 5.12646 15.8298 5.23093C15.7215 5.33615 15.5745 5.39628 15.4197 5.39628C14.8472 5.39628 14.383 5.84797 14.383 6.39587Z",
  fill: "#C4C4C4"
});

function SvgTicketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticketIcon.a964b320.svg";
export { ForwardRef as ReactComponent };